export default __webpack_public_path__ + "static/media/LOGIN_DESKTOP_20.2203af32.png";